import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';

import { Button } from '../../../components/Button';
import { Textarea } from '../../../components/Textarea';
import { ticketErrorRO } from '../ticketCopy';
import { useAddCommentMutation } from '../tickets.api';
import { CommentFormSchema, type CommentForm } from '../tickets.schema';

export function CommentComposer({ id }: { id: number }) {
    const [addComment, { isLoading }] = useAddCommentMutation();
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm<CommentForm>({
        resolver: zodResolver(CommentFormSchema),
        defaultValues: { body: '' },
    });

    const onSubmit = handleSubmit(async (values) => {
        try {
            await addComment({ id, values }).unwrap();
            reset({ body: '' });
        } catch (e) {
            toast.error(ticketErrorRO(e, 'Eroare la trimiterea comentariului.'));
        }
    });

    return (
        <form onSubmit={onSubmit} className="flex flex-col gap-2">
            <Textarea rows={2} placeholder="Scrie un comentariu..." {...register('body')} />
            {errors.body && <span className="text-xs text-red-600 dark:text-red-400">{errors.body.message}</span>}
            <div className="flex justify-end">
                <Button type="submit" disabled={isLoading}>
                    {isLoading ? 'Se trimite...' : 'Comenteaza'}
                </Button>
            </div>
        </form>
    );
}
